import { useState } from 'react';

import { useFetchPolicy } from '../../../hooks/api/policies/useFetchPolicy';

/**
 * hook to track the state of the selected licenses in the policy
 */
export default function usePolicyState() {
  const [selectedUncategorized, setSelectedUncategorized] = useState<Set<string>>(new Set());
  const [selectedDenied, setSelectedDenied] = useState<Set<string>>(new Set());
  const [selectedFlagged, setSelectedFlagged] = useState<Set<string>>(new Set());
  const [selectedApproved, setSelectedApproved] = useState<Set<string>>(new Set());

  const deselectAll = () => {
    setSelectedUncategorized(new Set());
    setSelectedDenied(new Set());
    setSelectedFlagged(new Set());
    setSelectedApproved(new Set());
  };

  return {
    useFetchPolicy,
    selectedUncategorized,
    setSelectedUncategorized,
    selectedDenied,
    setSelectedDenied,
    selectedFlagged,
    setSelectedFlagged,
    selectedApproved,
    setSelectedApproved,
    deselectAll,
  };
}
